module.exports = __webpack_public_path__ + "static/img/ink_roller.876c5fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/ink_roller.png
// module id = 451
// module chunks = 1